import { types, Instance, SnapshotIn } from 'mobx-state-tree';
import IAssessmentQuestion from './AssessmentQuestion';

export const Assessment = types
  .model('Assessment', {
    id: types.string,
    questions: types.array(IAssessmentQuestion),
    infoSlideKeys: types.array(types.string),
  })
  .views((self) => ({
    get hasNegativeAnswer() {
      const answer = (q: any) => q.answer === 'No';
      return self.questions.some(answer);
    },
    get keysForNegativeAnswer() {
      const answers = self.questions.filter(q => q.answer === 'No');

      return answers.map(answer => answer.key);
    },
    get lastQuestionIndex() {
      return self.questions.length - 1;
    },
    questionForKey(key: string) {
      const question = self.questions.find(q => q.key === key);

      if (!question) {
        throw new Error(`No question exists for key ${key}`)
      }

      return question;
    },
    get scoreComplete() {
      const isAnswered = self.questions.filter(question => question.isAnswered).length;
      let total = self.questions.length;

      if (self.id.toLocaleLowerCase() === "medical") {
        total = total - 3; // medical module has 3 coming soon modules
      }

      return +((isAnswered / total) * 100).toFixed(0);
    }
  }));

export default Assessment;
export interface IAssessment extends Instance<typeof Assessment> { }
export interface IAssessmentSnapshotIn extends SnapshotIn<typeof Assessment> {
  infoSlideKeys: string[];
}

